import messages from '../../data/messages.json'

export class MessageProvider {
  static provide(id: string, ...args: string[]): string {
    const message = messages.find(m => m.id === id)
    if (message == null) {
      return ''
    }

    let formatedContent = message.content
    for (let i = 0; i < args.length; i++) {
      formatedContent = formatedContent.replaceAll(`{${i}}`, args[i])
    }
    return formatedContent
  }
}
